var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fields-library fields-library-hide",
      attrs: { id: "fieldsLibrary" }
    },
    [
      _c("div", { staticClass: "title-component" }, [
        _vm._v(_vm._s(_vm.isComponent ? "COMPONENT" : "TOOLBOX"))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-search" }, [
        _c("i", { staticClass: "fa fa-search" }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchField,
              expression: "searchField"
            }
          ],
          attrs: { type: "text", placeholder: "Search", autocomplete: "off" },
          domProps: { value: _vm.searchField },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchField = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "content-component" },
            [_c("j-skeleton-field-library")],
            1
          )
        : _c(
            "div",
            { staticClass: "content-component" },
            _vm._l(_vm.fieldsLibrary, function(fields, index) {
              return _c(
                "div",
                { key: fields.section, staticClass: "field-section" },
                [
                  fields.section
                    ? _c("p", { staticClass: "title-section" }, [
                        _vm._v(
                          "\n        " + _vm._s(fields.section) + "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "field-list",
                      attrs: {
                        list: fields.fields,
                        group: {
                          name: "fieldsLibrary",
                          pull: "clone",
                          put: false
                        },
                        options: {
                          disabled:
                            _vm.propertiesOpened || _vm.showModalFieldLibrary
                        }
                      },
                      on: {
                        start: function($event) {
                          _vm.dragStart($event, index)
                        },
                        end: function($event) {
                          _vm.reset($event, index)
                        }
                      }
                    },
                    _vm._l(fields.fields, function(field) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hideFieldByConfig(field.type),
                              expression: "hideFieldByConfig(field.type)"
                            }
                          ],
                          key: field.type,
                          staticClass: "list",
                          attrs: { id: field.type }
                        },
                        [
                          _c("img", {
                            staticClass: "field-icon field-icon-active",
                            attrs: {
                              src: require("@/assets/new-form-ui/field-icon-active/" +
                                field.type +
                                ".svg")
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "field-icon field-icon-default",
                            attrs: {
                              src: require("@/assets/new-form-ui/field-icon/" +
                                field.type +
                                ".svg")
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(field.name))])
                        ]
                      )
                    })
                  )
                ],
                1
              )
            })
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-215653f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215653f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/FieldLibrary.vue
// module id = null
// module chunks = 